/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-27 17:27:56
 * @LastEditors: K
 * @LastEditTime: 2022-08-05 10:13:05
 */
import { Modal, Table } from 'antd';
import React, { ReactElement } from 'react'
import styles from "./Tenants.module.css";

export const ProductPriceModal = (props: {
  visible: boolean;
  productPriceModalList: any[]
  onCancel: () => void;
}): ReactElement => {

  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '产品类型',
      dataIndex: 'productName',
      key: 'productName',
    },
    {
      title: '时长/次数',
      dataIndex: 'durationNumStr',
      key: 'durationNumStr',
    },
    {
      title: '单价',
      key: 'defaultPrice',
      dataIndex: 'defaultPrice',
      render: (_: any, t: any) => {
        return t.defaultPrice.toFixed(2)
      },
    },
  ];

  return (
    <div >
      <Modal footer={null} width={600} title="产品价格表" visible={props.visible} onCancel={() => props.onCancel()}>
        <div className={styles.productPriceModalTableWrap}>
          <Table pagination={false} columns={columns} dataSource={props.productPriceModalList} />
        </div>
      </Modal>
    </div>
  );
}

